import Image from "next/image";
import Link from "next/link";
import { ImArrowUpRight2 } from "react-icons/im";

const CoursesAreaTwo = () => {
 const coursesData = [
  {
    title: "Bachelor of Science",
    description: "A comprehensive program that builds a strong foundation in science and opens doors to multiple career opportunities.",
    instructor: {
      name: "Dr. Anjali Sharma",
      image: "/images/users/user7.webp",
    },
  },
  {
    title: "Diploma",
    description: "Skill-focused courses designed to provide practical knowledge and hands-on experience for early career growth.",
    instructor: {
      name: "Prof. Rajesh Kumar",
      image: "/images/users/user8.webp",
    },
  },
  {
    title: "Nursing",
    description: "A professional program that trains students in patient care, healthcare practices, and hospital management.",
    instructor: {
      name: "Ms. Neha Verma",
      image: "/images/users/user6.webp",
    },
  },
];


  return (
    <div className="courses-area pb-95">
      <div className="container">
        <div className="section-title d-md-flex align-items-center justify-content-between">
          <div className="title">
            <h2 className="text-uppercase fw-semibold fs-3">
              Our Popular Courses
            </h2>
            <p>
               Explore a wide range of courses designed to shape your knowledge and skills for the future.
            </p>
          </div>
          <Link
            href="courses"
            className="link-btn d-inline-block text-center rounded-circle fw-medium"
          >
            <span className="d-block">Explore All Courses</span>
               <ImArrowUpRight2 size={30} className="brn"/>

          </Link>
        </div>
        <div
          className="row justify-content-center"
         
        >
          {coursesData.slice(0, 3).map((course, idx) => (
            <div key={idx} className="col-lg-4 col-sm-6">
              <div className="single-course-item bg-f6ffeb mb-25 position-relative">
                <div className="number lh-1 z-2  mt-3 fs-2">0{idx + 1}</div>
                <div className="z-5 h-30">
                    <h3 className="fs-5">
                  <Link href="course-details ">{course.title}</Link>
                     </h3>
                <p className="fs-6">{course.description}</p>
                </div>
                <div className="instructor d-flex align-items-center">
                  <Image
                    width={50}
                    height={50}
                    sizes="100vw"
                    src={course.instructor.image}
                    className="rounded-circle"
                    alt="user-image"
                  />
                  <div>
                    <h4 className="fs-6">{course.instructor.name}</h4>
                    <span className="fs-6">Instructor</span>
                  </div>
                </div>
                <Link href="course-details" className="link-btn d-inline-block">
                  {/* <Image
                    width={20}
                    height={20}
                    src="/images/icons/arrow-right-up.svg"
                    alt="arrow-right-up"
                  /> */}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoursesAreaTwo;
